import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { XCircle } from "lucide-react";
import { OgmaLogo } from "@/components/OgmaLogo";
import { Button } from "@/components/ui/Button";

export function CheckoutCancelPage() {
  const { t } = useTranslation();

  return (
    <div className="flex h-screen w-screen items-center justify-center bg-muted/40">
      <div className="flex w-96 flex-col items-center gap-6 rounded-xl border border-border bg-card px-10 py-12 text-center shadow-sm">
        <OgmaLogo size={40} />
        <XCircle className="size-10 text-muted-foreground" />
        <div className="flex flex-col gap-1">
          <h1 className="text-lg font-semibold text-foreground">{t("checkout.cancel.title")}</h1>
          <p className="text-sm text-muted-foreground">{t("checkout.cancel.description")}</p>
        </div>
        <Button
          className="w-full"
          render={<Link to="/account">{t("checkout.cancel.backToAccount")}</Link>}
        />
      </div>
    </div>
  );
}
